<div class="row divRow">
  <form [formGroup]="form" class="col-12 row">
    <div class="col-4 center">
      <mat-form-field class="matform" appearance="outline">
        <mat-label>Unidad</mat-label>
        <mat-select
          multiple
          (selectionChange)="
            form.value.case_type.length == 0 ? getUsers() : findUser()
          "
          formControlName="unit"
        >
          <mat-option *ngFor="let unit of getUnits" [value]="unit._id">{{
            unit.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4 center">
      <mat-form-field class="matform" appearance="outline">
        <mat-label>Tipo de caso</mat-label>
        <mat-select
          multiple
          formControlName="case_type"
          (selectionChange)="
            form.value.case_type.length == 0 ? getUsers() : findUser()
          "
        >
          <mat-option
            *ngFor="let caseType of caseTypes"
            [value]="caseType._id"
            >{{ caseType.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4 center">
      <mat-form-field class="matform" appearance="outline">
        <mat-label>Usuario</mat-label>
        <mat-select formControlName="user" multiple>
          <mat-option *ngFor="let user of usersSelected" [value]="user._id">{{
            user.username
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6 center">
      <mat-form-field appearance="outline">
        <mat-label>Fecha inicio</mat-label>
        <input
          formControlName="start"
          matInput
          [max]="form.value.end"
          [matDatepicker]="dp2"
        />
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-6 center">
      <mat-form-field appearance="outline">
        <mat-label>Fecha final</mat-label>
        <input
          formControlName="end"
          matInput
          [min]="form.value.start"
          [matDatepicker]="dp1"
          [disabled]="!form.value.start"
        />
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>
    </div>
  </form>
  <div class="col-6 right">
    <button
      [disabled]="!form.valid"
      mat-button
      class="primary-btn"
      (click)="search()"
    >
      Buscar
    </button>
  </div>
  <div class="col-6 left">
    <button mat-button class="primary-btn res" (click)="cleanFilter()">
      Restablecer
    </button>
  </div>
</div>

<div class="generalReports">
  <general-report-resume></general-report-resume>
</div>
<!-- <div class="generalReports">
  <unit-report-resume></unit-report-resume>
</div> -->

<div class="generalReports">
  <case-type-report-resume></case-type-report-resume>
</div>
<div class="generalReports">
  <user-report-resume></user-report-resume>
</div>
